import React from "react";
import "./SubjectWiseAnalysis.css";

const SubjectWiseAnalysis = ({ subjects = [] }) => {
  if (!subjects.length) return null;

  return (
     <div className="subjectwise-section">
  
      <h2 className="subjectwise-title">Subject-wise Analysis</h2>

    <div className="subjectwise-wrapper">
      {subjects.map((sub, index) => (
        <div className="subject-card" key={index}>
          
          {/* Header */}
          <div className="subject-header">
            <h3>{sub.subject}</h3>
            <span
              className="dot"
              style={{ background: sub.color }}
            ></span>
          </div>

          {/* Marks */}
          <div className="details-row">
            <span>Marks:</span>
            <span className="value">{sub.score}</span>
          </div>

          {/* Percentage */}
          <div className="details-row">
            <span>Percentage(%):</span>
            <span className="value percentage">
              {sub.analysis?.find((x) => x.label === "Percentage(%):")?.value}
            </span>
          </div>

          {/* Rank */}
          <div className="details-row">
            <span>Rank:</span>
            <span className="value">
              {sub.analysis?.find((x) => x.label === "Rank:")?.value}
            </span>
          </div>

          {/* Highest */}
          <div className="details-row">
            <span>Highest:</span>
            <span className="value">
              {sub.analysis?.find((x) => x.label === "Highest:")?.value}
            </span>
          </div>

          {/* Average */}
          <div className="details-row">
            <span>Average:</span>
            <span className="value">
              {sub.analysis?.find((x) => x.label === "Average:")?.value}
            </span>
          </div>

        </div>
      ))}
    </div>
    </div>
  );
};

export default SubjectWiseAnalysis;
